import React, { useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import BasicReport from "./components/ScoreREports/BasicReport";
import loaderGif from "../accerts/gifs/LoaderGif.gif";
import Timer from "../accerts/gifs/timerGIf.gif";
import { CONFIG_VARS } from "./constants/configaration";
import Footer from "./components/Footer/Footer";
import EventHeader from "./components/EventHeader";
import WITReportContent from "./components/WIT/WITReportContent";
import {
  GIST_REPORT_EVENT,
  getWitAdvancedReport,
  hasBasicReport,
  isWitAdvancedReportReady,
} from "./components/WIT/witUtils";

const extractReportTypeFromUrl = () => {
  const pathParts = new URL(window.location.href).pathname.split("/");

  if (pathParts.length <= 2) return GIST_REPORT_EVENT;

  return pathParts[1].replace("-report", "") || GIST_REPORT_EVENT;
};

export const WITReports = () => {
  const { crnId, eventId } = useParams();
  const [reportData, setReportData] = useState(null);
  const [advanceReport, setAdvanceReport] = useState(null);
  const [progressordata, setProgressordata] = useState({});
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(null);
  const [advaceLoader, setAdvaceLoader] = useState(false);
  const hasCalledRef = useRef(false);

  const postAdvancereport = async (evtId, crn, reportType) => {
    setAdvaceLoader(true);
    try {
      const res = await fetch(
        `${CONFIG_VARS.baseUrl}/exams/advanced-report?event_id=${evtId}&crn_id=${crn}&event=${reportType}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Product-Id": "100",
            "Tenant-Id": "99999",
          },
          body: "",
        },
      );

      if (res.status === 201 || res.status === 200) {
        await fetchReports(crn, evtId);
      }
    } catch (err) {
      console.error("Error creating GIST advanced report:", err);
    } finally {
      setAdvaceLoader(false);
    }
  };

  const fetchReports = async (crn, evt) => {
    setLoader(true);
    setError(null);

    try {
      const cacheBuster = new Date().getTime();
      const res = await fetch(
        `${CONFIG_VARS.S3buket}/${crn}_${evt}.json?cb=${cacheBuster}`,
        { mode: "cors" },
      );

      if (res?.status === 200) {
        const data = await res.json();

        if (!hasBasicReport(data)) {
          setError("Reports are not available yet ..!");
          setLoader(false);
          return;
        }

        setReportData(data);
        setProgressordata(data?.basic_report?.section_wise_marks);
        setAdvanceReport(null);

        const examSubmittedAt = new Date(data?.exam_submitted_at);
        const currentTime = new Date();
        const timeDifference = currentTime - examSubmittedAt;
        const reportType = extractReportTypeFromUrl();

        if (timeDifference > 2 * 60 * 60 * 1000) {
          if (!isWitAdvancedReportReady(data)) {
            postAdvancereport(evt, crn, reportType);
          } else {
            setAdvanceReport(getWitAdvancedReport(data));
          }
        }

        hasCalledRef.current = false;
        setLoader(false);
      } else if (!hasCalledRef.current) {
        hasCalledRef.current = true;
        await postAdvancereport(evt, crn, extractReportTypeFromUrl());
        setLoader(false);
      } else {
        setError("Reports are not available yet ..!");
        setLoader(false);
      }
    } catch (err) {
      console.error("Error fetching GIST report:", err);
      setError("Reports are not available yet ..!");
      setLoader(false);
    }
  };

  useEffect(() => {
    hasCalledRef.current = false;
    fetchReports(crnId, eventId);
  }, [crnId, eventId]);

  const handleRetry = () => {
    hasCalledRef.current = false;
    fetchReports(crnId, eventId);
  };

  return (
    <div className="Rep_main_cont wit-page">
      <EventHeader reportData={reportData} />

      {!loader && !error ? (
        <div>
          {progressordata && Object.keys(progressordata).length > 0 && (
            <>
              <BasicReport
                currentExam="hot"
                reportData={reportData}
                progressordata={progressordata}
              />
              {advaceLoader && (
                <div className="Rep_timer-cont">
                  <h1>But Wait!</h1>
                  <p className="Rep_timer-des">
                    <span>We are generating a detailed report for you.</span>
                  </p>
                  <img src={Timer} alt="Timer" />
                </div>
              )}
            </>
          )}
          {advanceReport && (
            <WITReportContent advancedReport={advanceReport} />
          )}
        </div>
      ) : (
        <div className="Loader">
          {!error ? (
            <>
              <img src={loaderGif} alt="loading" />
              <h4>Wait we are preparing your reports....</h4>
            </>
          ) : (
            <>
              <p>{error}</p>
              <button type="button" className="RefetchBtn" onClick={handleRetry}>
                Retry
              </button>
            </>
          )}
        </div>
      )}

      <Footer />
    </div>
  );
};

export default WITReports;
